export default __webpack_public_path__ + "static/media/584.56869aee.png";